import { computed, ref, onBeforeMount } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useHeightProps } from "./assets/index-BWUsUM8p.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import { e as emits, c as changeEvent, a as modelPropName } from "./assets/SingleInput-CdYfqMCu.js";
import XTableRow from "./XTableRow.js";
import { u as useProps, F as FirstColumn } from "./assets/FirstColumn-CsFeJ2aI.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-BJV0_gaH.js";
import "./assets/index-DKxr0Yto.js";
import "./XSkeletonLoader.js";
import "./XListItem.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./XCheckbox.js";
import "./BaseOption.js";
import "./XFormField.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/SingleMessage-Dv2wNb7f.js";
import "./XLink.js";
import "./XTooltip.js";
import "./assets/XDropdown-Bc_0Fycm.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./MultipleInputs.js";
import "./XEllipsis.js";
function useGridStyle(props) {
  const MAX_COLSPAN = 16;
  function generateDefaultColspan(maxColspan, totalColspan, headersWithoutColspan) {
    return (maxColspan - totalColspan) / headersWithoutColspan;
  }
  function getTotalColspanSum() {
    return props.headers.reduce(
      (prevTotalColspan, header2) => prevTotalColspan + ((header2 == null ? void 0 : header2.colspan) || 0),
      0
    );
  }
  function getColsWithoutColspan() {
    return props.headers.filter((item) => !item.colspan).length;
  }
  const defaultColspan = computed(() => {
    return generateDefaultColspan(MAX_COLSPAN, getTotalColspanSum(), getColsWithoutColspan());
  });
  const columnsColspan = computed(
    () => props.headers.map(({ colspan }) => colspan || defaultColspan.value)
  );
  const gridTemplateColumns = computed(
    () => columnsColspan.value.map((colspan) => `${colspan}fr`).join(" ")
  );
  return {
    gridTemplateColumns
  };
}
const XTable$1 = "_XTable_1mo7m_1";
const header = "_header_1mo7m_4";
const headerRow = "_headerRow_1mo7m_14";
const headerCol = "_headerCol_1mo7m_18";
const sortable = "_sortable_1mo7m_29";
const isDisabled = "_isDisabled_1mo7m_32";
const sortIcon = "_sortIcon_1mo7m_41";
const rowsContainer = "_rowsContainer_1mo7m_44";
const style0 = {
  XTable: XTable$1,
  header,
  headerRow,
  headerCol,
  sortable,
  isDisabled,
  sortIcon,
  rowsContainer
};
const { getHeightStyles } = useHeightProps();
const { setupTestId } = useDataTestIdProp();
const { globalProps, rowProps } = useProps();
const VALID_SORT_ORDERS = {
  none: {
    icon: "arrow-up-arrow-down",
    value: null
  },
  asc: {
    icon: "arrow-up",
    value: "asc"
  },
  desc: {
    icon: "arrow-down",
    value: "desc"
  }
};
const __default__ = {
  name: "XTable",
  components: {
    XTableRow,
    XIcon,
    FirstColumn
  }
};
const _sfc_main = Object.assign(__default__, {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    noHeader: {
      type: Boolean,
      default: false
    },
    previewLoadingRows: {
      type: Number,
      default: 5
    },
    icon: {
      type: Object,
      default: null
    },
    ...globalProps,
    ...rowProps
  },
  emits: ["sort", "select:all", ...emits],
  setup(__props, { emit }) {
    const props = __props;
    const changeEventName = ref(changeEvent);
    const columnsSortOrder = ref({});
    const selectedRows = ref([]);
    const { formatTestId } = setupTestId(props);
    const { heightStyles } = getHeightStyles(props);
    function transformRow(row) {
      return {
        ...row,
        icon: (row == null ? void 0 : row.icon) || props.icon,
        _raw: row
      };
    }
    function handleColumnSort(header2, canUpdateOrder = true) {
      if (!header2.sortable) return;
      const currentColumnOrder = columnsSortOrder.value[header2.value];
      const currentOrderIndex = Object.values(VALID_SORT_ORDERS).findIndex(
        (order) => order.value === currentColumnOrder
      );
      const nextColumnOrder = Object.values(VALID_SORT_ORDERS)[(currentOrderIndex + 1) % Object.values(VALID_SORT_ORDERS).length].value;
      const columnNewOrderIndex = canUpdateOrder ? nextColumnOrder : (header2 == null ? void 0 : header2.order) || VALID_SORT_ORDERS.none.value;
      const previousColumnsSortOrder = {
        ...columnsSortOrder.value
      };
      const currentColumnSortOrder = {
        [header2.value]: columnNewOrderIndex
      };
      columnsSortOrder.value = {
        ...previousColumnsSortOrder,
        ...currentColumnSortOrder
      };
      if (canUpdateOrder) {
        emit("sort", columnNewOrderIndex, header2);
      }
    }
    function sortColumnsBeforeMount() {
      if (props.headers.length > 0) {
        props.headers.forEach((header2) => handleColumnSort(header2, false));
      }
    }
    const enabledItems = computed(() => props.items.filter((item) => !item.disabled));
    const hasItems = computed(() => {
      var _a;
      return !!((_a = enabledItems.value) == null ? void 0 : _a.length);
    });
    const isSelectedAll = computed(
      () => hasItems.value && selectedRows.value.length === enabledItems.value.length
    );
    function selectAllRows(shouldSelect) {
      selectedRows.value = shouldSelect ? enabledItems.value : [];
      emit("select:all", selectedRows.value);
    }
    function getColumnSortOrderIcon(column) {
      const columnSortOrder = columnsSortOrder.value[column];
      return columnSortOrder ? VALID_SORT_ORDERS[columnSortOrder].icon : VALID_SORT_ORDERS.none.icon;
    }
    const loadingRows = computed(() => {
      var _a, _b;
      if (((_a = props.items) == null ? void 0 : _a.length) > 0 && props.previewLoadingRows > ((_b = props.items) == null ? void 0 : _b.length)) {
        return props.items.length;
      }
      return props.previewLoadingRows;
    });
    const tableItems = computed(
      () => props.loading ? Array.from({ length: loadingRows.value }, transformRow) : props.items.map(transformRow)
    );
    const doesAnyRowHaveIcon = computed(() => tableItems.value.some((item) => item.icon));
    const headerRowDataTestId = computed(() => formatTestId("headerRow"));
    const { gridTemplateColumns } = useGridStyle(props);
    const firstColumnProps = computed(() => ({
      [modelPropName]: isSelectedAll.value,
      checkable: props.checkable,
      loading: props.loading,
      canShowIconSpace: doesAnyRowHaveIcon.value
    }));
    onBeforeMount(() => {
      sortColumnsBeforeMount();
    });
    return { __sfc: true, getHeightStyles, setupTestId, globalProps, rowProps, VALID_SORT_ORDERS, props, emit, changeEventName, columnsSortOrder, selectedRows, formatTestId, heightStyles, transformRow, handleColumnSort, sortColumnsBeforeMount, enabledItems, hasItems, isSelectedAll, selectAllRows, getColumnSortOrderIcon, loadingRows, tableItems, doesAnyRowHaveIcon, headerRowDataTestId, gridTemplateColumns, firstColumnProps, XIcon, changeEvent, XTableRow, FirstColumn };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _vm.$style.XTable, attrs: { "role": "table", "data-testid": _vm.dataTestid } }, [_c("div", { class: _vm.$style.header, attrs: { "role": "rowgroup" } }, [_setup.hasItems ? _c(_setup.FirstColumn, _vm._b({ attrs: { "data-testid": _setup.headerRowDataTestId, "role": "columnheader" }, on: _vm._d({}, [_setup.changeEventName, _setup.selectAllRows]) }, "FirstColumn", _setup.firstColumnProps, false)) : _vm._e(), !_vm.noHeader ? _c("div", { class: _vm.$style.headerRow, style: {
    gridTemplateColumns: _setup.gridTemplateColumns
  }, attrs: { "role": "row", "data-testid": _setup.headerRowDataTestId } }, _vm._l(_vm.headers, function(header2, headerIndex) {
    return _c("div", { key: `header-${header2.value}`, class: [_vm.$style.headerCol, header2.sortable && _vm.$style.sortable], attrs: { "role": "columnheader", "data-testid": _setup.formatTestId(`headerCol-${header2.label}`), "tabindex": header2.sortable ? "0" : "-1" }, on: { "click": function($event) {
      return _setup.handleColumnSort(header2);
    }, "keyup": function($event) {
      if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
      return _setup.handleColumnSort(header2);
    } } }, [_vm._t(`header-${header2.value}`, function() {
      return [_vm._v(" " + _vm._s(header2.label) + " ")];
    }, { "index": headerIndex, "header": header2 }), header2.sortable ? _c(_setup.XIcon, { class: _vm.$style.sortIcon, attrs: { "icon": _setup.getColumnSortOrderIcon(header2.value) } }) : _vm._e()], 2);
  }), 0) : _vm._e()], 1), _c("ul", { class: _vm.$style.rowsContainer, attrs: { "role": "rowgroup" } }, [_vm._l(_setup.tableItems, function(item, index) {
    return _vm._t((item == null ? void 0 : item.slot) ? `item-${item.slot}` : "item", function() {
      return [_c(_setup.XTableRow, _vm._b({ key: `row-${index}`, attrs: { "item": item, "headers": _vm.headers, "max-row-lines": _vm.maxRowLines, "grid-template-columns": _setup.gridTemplateColumns, "loading": _vm.loading, "checkable": _vm.checkable, "can-show-icon-space": _setup.doesAnyRowHaveIcon, "data-testid": _vm.dataTestid }, on: _vm._d({}, [_setup.changeEventName, ($event) => _vm.$emit(_setup.changeEvent, $event)]), scopedSlots: _vm._u([{ key: "column", fn: function({ column }) {
        return [_vm._t(`item-${item.slot}-col-${column.value}`, null, { "item": item, "column": column }), _vm._t(`items-col-${column.value}`, null, { "item": item, "column": column })];
      } }], null, true), model: { value: _setup.selectedRows, callback: function($$v) {
        _setup.selectedRows = $$v;
      }, expression: "selectedRows" } }, "XTableRow", _setup.heightStyles, false))];
    }, null, {
      item,
      index,
      headers: _vm.headers,
      gridTemplateColumns: _setup.gridTemplateColumns,
      selectedRows: _setup.selectedRows,
      doesAnyRowHaveIcon: _setup.doesAnyRowHaveIcon,
      dataTestid: _vm.dataTestid,
      heightStyles: _setup.heightStyles
    });
  })], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTable = __component__.exports;
export {
  VALID_SORT_ORDERS,
  XTable as default
};
